import { ChartUnavailableReason } from "../../chart.models";
import Footer from "../footer/footer.component";

import styles from "./chart-unavailable.module.scss";

// An upstream failure is transient and worth retrying; an empty chart is not the
// visitor's problem to retry, so the two read differently.
const MESSAGE_FOR_REASON: Record<ChartUnavailableReason, string> = {
	upstream_error: "This chart is temporarily unavailable. Please try again shortly.",
	no_releases: "No chart data has been published yet. Check back soon."
};

// Shown in place of a chart when there is no chart release to render. Keeps the page
// shell and the links to the other charts, so a charts API failure or an unpublished
// chart is a labelled empty state rather than a 500.
const ChartUnavailable: React.FC<{
	name: string,
	reason: ChartUnavailableReason
}> = ({name, reason}) => {
	return (
		<>
			<div className={styles.unavailable}>
				<h2 className={styles.title}>{name}</h2>
				<p className={styles.message}>{MESSAGE_FOR_REASON[reason]}</p>
			</div>
			<div className={styles.footer}>
				<Footer/>
			</div>
		</>
	);
};

export default ChartUnavailable;
